import React, { Component } from "react";
import { TableContainer, tableHeadClasses, Button } from "@mui/material";
import { CSSTransition } from "react-transition-group";
import { X, Code, Clock, ArrowDown, Loader, ChevronsRight, Settings, BarChart } from "react-feather";
import moment from "moment-timezone";
import _ from "lodash";
import "./daghistory.css";
import "../../../styles/table.css";
import DatajoltSpinner from "../../../components/global/DatajoltSpinner.js";
import { Accordion } from "react-bootstrap";
import { fetchLastRuns } from "../../functions.js";
import Table from "../../../components/global/Table";
import LogsTable from "../LogsTable.js";
import { 
  getTargetDAGDataService, 
  getTasksService, 
  getTasksAcrossDagsService 
} from "../../../services/tables.js";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

var customer_timezone;
(function retryFetch(retryDelay = 4000, maxAttempts = 2, currentAttempt = 1) {
  var localTimezone = localStorage.getItem("timezone");

  if (!localTimezone && currentAttempt <= maxAttempts) {
    console.log(
      `Attempt ${currentAttempt}: Timezone not found, retrying in ${retryDelay}ms...`
    );
    setTimeout(
      () => retryFetch(retryDelay, maxAttempts, currentAttempt + 1),
      retryDelay
    );
  } else if (localTimezone) {
    customer_timezone = localTimezone; // Update the broader scoped variable
    // Proceed with your logic here
  } else {
    console.log("Max attempts reached. Failed to get timezone.");
    // Handle failure case here
  }
})();

class DagHistory extends Component {
  constructor(props) {
    super(props);
    this.state = {
      historyTargetId: this.props.historyModalId || new URLSearchParams(window.location.search).get('history_modal'),
      loading: false,
      historical_runs_available: true,
      DAGs: [],
      running_dags: [],
      loading_metadata: true,
      dag_runs: [],
      last_succesful_runs: {},
      dag_pause_statuses: {},
      historical_dag_runs: [],
      progress: 40,
      fetching_last_runs: false,
      selected_job: "",
      schedule_frequency: false,
      schedule_details: false,
      scheduling: false,
      modal_logs: null,
      schedule_day: false,
      dag_logs: [],
      selected_job_logo: "",
      selected_job_type: "",
      isShowingDagHistoryTable: false,
      showTaskDuration: null,
      showTaskGantt: null,
      gantt_logs: [],
      durationsAccordionOpen: false,
      runsAccordionOpen: true,
    };
  }

  componentDidMount() {
    this.setState({ 
      fetching_last_runs: true,
      isShowingDagHistoryTable: true 
    });
    
    window.scrollTo({
      top: 0,
    });
    
    this.getTargetDAGData();
    
    setTimeout(() => {
      document.body.style.overflow = "hidden";
    }, 500);
    
    this.fetchDAGLastRunsTimerMounted = true;
    this.fetchDAGLastRunsTimeout = this.fetchDAGLastRunsTimer();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.historyModalId !== this.props.historyModalId) {
      this.setState({ 
        historyTargetId: this.props.historyModalId 
      }, () => {
        this.getTargetDAGData();
      });
    }
  }

  componentWillUnmount() {
    document.body.style.overflow = "";
    this.fetchDAGLastRunsTimerMounted = false;
    clearTimeout(this.fetchDAGLastRunsTimeout);
  }

  getTargetDAGData = async () => {
    const history_modal = this.state.historyTargetId;

    if (this.props.dagList) {
      const targetDAG = this.props.dagList.find(
        (DAG) => DAG.id === history_modal || DAG.workflowname === history_modal || DAG.dag_id === history_modal || DAG.alias === history_modal
      );

      if (!targetDAG && !this.props.isWorkflowView) {
        console.warn("No matching DAG found for ID:", history_modal);
        this.setState({ 
          historical_runs_available: false,
          fetching_last_runs: false 
        });
        return;
      }

      // For workflow view, use the history_modal directly as the task name
      if (this.props.isWorkflowView) {
        this.setState({
          historyTargetId: history_modal,
          selected_job_type: targetDAG?.type || ''
        });
        this.openDAGHistory(history_modal, targetDAG?.logo);
        return;
      }

      // For taps and dags views
      const displayName = targetDAG?.alias || targetDAG?.workflowname || targetDAG?.id || history_modal;
      const taskId = targetDAG?.datajolt_task_id || targetDAG?.dag_id || history_modal;
      
      this.setState({
        historyTargetId: displayName,
        selected_job_type: targetDAG?.type || '',
        selected_logo: targetDAG?.logo
      });

      this.openDAGHistory(taskId, targetDAG?.logo);
      return;
    }

    this.setState({ 
      DAGs: [], 
      loading: true, 
      fetching_last_runs: true,
    });
    this.setState({ progress: 80 });

    const response = await getTargetDAGDataService();

    if(response) {
      this.setState({
        dag_pause_statuses: response.data["pauses_status"],
        DAGs: response.data["dags_list"],
      });

      const targetDAG = response.data["dags_list"].find(
        (DAG) => DAG.workflowname === history_modal || DAG.dag_id === history_modal || DAG.alias === history_modal
      );

      // Update display name here as well
      const displayName = targetDAG?.alias || targetDAG?.workflowname || history_modal;
      const taskId = this.props.isWorkflowView ? history_modal : targetDAG?.dag_id || history_modal;

      this.setState({
        historyTargetId: displayName
      });

      this.openDAGHistory(taskId, targetDAG?.logo);
    } else {
      this.setState({ historical_runs_available: false });
    }
    
    this.setState({
      progress: 100,
      loading: false,
      fetching_last_runs: false,
    });
  };

  fetchDAGLastRunsTimer = (datajolt_task_id, no, bool, time) => {
    if (datajolt_task_id)
      setTimeout(() => {
        this.fetchDAGLastRunsTimerMounted &&
          fetchLastRuns(datajolt_task_id, bool, this.setState.bind(this));
      }, time);
  };

  openDAGHistory = (datajolt_task_id, logo) => {
    if (!datajolt_task_id) {
      console.warn("No task ID provided to openDAGHistory");
      this.setState({ 
        historical_runs_available: false,
        fetching_last_runs: false,
        progress: 100
      });
      return;
    }

    this.setState({
      selected_job: datajolt_task_id,
      dag_id: datajolt_task_id,
      modal_history: true,
      selected_logo: logo,
    });
    
    // Only pass task_name if isWorkflowView prop is true
    const task_name = this.props.isWorkflowView ? this.state.historyTargetId : null;
        
    fetchLastRuns(
      datajolt_task_id, 
      50, 
      this.setState.bind(this), 
      () => this.fetchDAGLastRunsTimerMounted,
      task_name
    );
  };

  gettasks = async (dag_state, dag_id, dag_run_id, started_at) => {
    if (this.state.modal_logs === dag_run_id) {
      this.setState({
        modal_logs: false,
        dag_logs: [],
      });
      return;
    }
    this.setState({
      fetching_logs: true,
      progress: 40,
      dag_started_at: started_at,
      selected_dag_state: dag_state,
      loading_log_id: dag_run_id,
    });

    // Choose the appropriate service based on whether we're in workflow view or single-task view
    const serviceFunction = (this.props.isWorkflowView || this.props.hideTaskTimeline) ? 
      getTasksAcrossDagsService : 
      getTasksService;

    const response = await serviceFunction({
      dag_state,
      dag_id,
      dag_run_id,
      dag_started_at: started_at,
      ...((this.props.isWorkflowView || this.props.hideTaskTimeline) && { task_name: this.state.historyTargetId })
    });

    if(response) {
      this.setState({
        modal_logs: dag_run_id,
        dag_logs: response.data.logs,
      });
    }

    this.setState({
      fetching_logs: false,
      progress: 100,
      loading_log_id: false,
    });
  };

  getTasksForGantt = async (dag_state, dag_id, dag_run_id, started_at) => {
    this.setState({
      fetching_gantt: true,
      progress: 40,
    });

    // Choose the appropriate service based on whether we're in workflow view
    const serviceFunction = this.props.isWorkflowView ? 
      getTasksAcrossDagsService : 
      getTasksService;

    const response = await serviceFunction({
      dag_state,
      dag_id,
      dag_run_id,
      dag_started_at: started_at,
      ...(this.props.isWorkflowView && { task_name: this.state.historyTargetId })
    }, false); // showToast = false for Gantt chart

    if(response) {
      this.setState({
        gantt_logs: response.data.logs,
      });
    }

    this.setState({
      fetching_gantt: false,
      progress: 100,
    });
  };

  transformDataForGantt = (logs) => {
    console.log('GANTT DEBUG - First log:', logs?.[0]);
    console.log('GANTT DEBUG - All logs:', logs);
    console.log('GANTT DEBUG - Sample log fields:', logs?.[0] ? Object.keys(logs[0]) : 'No logs');
    
    if (!logs || logs.length === 0) return { labels: [], datasets: [] };

    // Sort logs by start_date ascending (earliest first)
    const sortedLogs = [...logs].sort((a, b) => {
      if (!a.start_date) return 1;
      if (!b.start_date) return -1;
      return moment.utc(a.start_date).diff(moment.utc(b.start_date));
    });

    // Find the earliest start time to use as baseline
    const earliestStart = sortedLogs.find(log => log.start_date)?.start_date;
    const baselineTime = earliestStart ? moment.utc(earliestStart).valueOf() : 0;

    // Transform for Chart.js horizontal timeline  
    const customer_timezone = localStorage.getItem("timezone");
    const labels = sortedLogs.map(log => log.task_id);
    
    const datasets = [{
      label: 'Task Duration',
      data: sortedLogs.map((log, index) => {
        // Try multiple possible field names
        const startTime = log.started_at || log.start_date || log.start_time;
        const endTime = log.ended_at || log.end_date || log.end_time;
        
        console.log(`GANTT DEBUG - Task ${index} (${log.task_id}):`, {
          started_at: log.started_at,
          start_date: log.start_date,
          start_time: log.start_time,
          ended_at: log.ended_at,
          end_date: log.end_date,
          end_time: log.end_time,
          resolved_startTime: startTime,
          resolved_endTime: endTime,
          state: log.state
        });
        
        if (!startTime) {
          console.log(`GANTT DEBUG - Task ${log.task_id} missing start timestamp, using default 0.1`);
          return 0.1; // Minimum for visibility
        }

        const start = moment.utc(startTime);
        let duration;
        
        if (endTime) {
          const end = moment.utc(endTime);
          duration = end.diff(start, 'minutes', true);
        } else {
          // For running tasks, use current time
          const now = moment.utc();
          duration = now.diff(start, 'minutes', true);
          console.log(`GANTT DEBUG - Task ${log.task_id} is running, calculated elapsed time: ${duration} minutes`);
        }
        
        console.log(`GANTT DEBUG - Task ${log.task_id} duration:`, {
          startTime,
          endTime,
          startParsed: start.format(),
          endParsed: endTime ? moment.utc(endTime).format() : 'N/A (running)',
          calculatedDuration: duration,
          finalDuration: Math.max(0.1, duration)
        });
        
        return Math.max(0.1, duration); // Ensure minimum 0.1 minutes for visibility
      }),
      backgroundColor: sortedLogs.map(log => {
        if (log.state === 'SUCCESS') return 'rgba(84, 203, 117, 0.8)';
        if (log.state === 'FAILED') return 'rgba(255, 99, 132, 0.8)';
        if (log.state === 'SKIPPED') return 'rgba(169, 169, 169, 0.8)';
        return 'rgba(54, 162, 235, 0.8)';
      }),
      borderColor: sortedLogs.map(log => {
        if (log.state === 'SUCCESS') return 'rgba(84, 203, 117, 1)';
        if (log.state === 'FAILED') return 'rgba(255, 99, 132, 1)';
        if (log.state === 'SKIPPED') return 'rgba(169, 169, 169, 1)';
        return 'rgba(54, 162, 235, 1)';
      }),
      borderWidth: 1,
      // Store additional data for tooltips
      taskData: sortedLogs.map(log => {
        const startTime = log.started_at || log.start_date || log.start_time;
        const endTime = log.ended_at || log.end_date || log.end_time;
        
        return {
          status: log.state,
          startFormatted: startTime ? moment.utc(startTime).tz(customer_timezone)?.format("HH:mm:ss") : 'N/A',
          endFormatted: endTime ? moment.utc(endTime).tz(customer_timezone)?.format("HH:mm:ss") : 'N/A',
          duration: startTime && endTime 
            ? moment.utc(endTime).diff(moment.utc(startTime), 'minutes', true)
            : startTime 
              ? moment.utc().diff(moment.utc(startTime), 'minutes', true) 
              : 0
        };
      })
    }];

    return { labels, datasets, sortedLogs };
  };

  render() {
    const customer_timezone = localStorage.getItem("timezone");
    return (
      <div id="history-table-container">
        <div
          style={{ display: "flex", justifyContent: "flex-start" }}
          className="history-table-content-container"
        >
          <CSSTransition
            in={this.state.isShowingDagHistoryTable}
            classNames="right-slide"
            timeout={300}
            unmountOnExit
          >
            <div className="history-sidebar">
              <header className="history-heading">
                {this.state.selected_logo ? (
                  <img
                    alt="dag logo"
                    src={this.state.selected_logo}
                    style={{
                      width: "50px",
                      objectFit: "cover",
                    }}
                  ></img>
                ) : null}
                <b className="history-heading-name">
                  Historical Runs:&nbsp;
                  {this.state.historyTargetId}
                  &nbsp;
                </b>
                <div style={{ display: "flex", gap: "8px", marginLeft: "auto" }}>
                  <Button
                    variant="contained"
                    sx={{
                      color: "white",
                      border: "1px solid #d0d5dd",
                      borderRadius: "5px",
                      background: "#abaaaa",
                      padding: "8.5px 15px",
                      fontWeight: "500",
                      fontSize: "11px",
                    }}
                    onClick={() => this.props.onClose()}
                  >
                    <X size={14} className="close-history-sidebar-icon" />
                    Close
                  </Button>
                </div>
              </header>

              {/* Durations Accordion */}
              <Accordion defaultActiveKey={this.state.durationsAccordionOpen ? "0" : ""} className="pl-0 modern-accordion mb-3" style={{ margin: "10px 0" }}>
                <Accordion.Item
                  eventKey="0"
                  className="bg-white"
                  style={{
                    borderRadius: '18px',
                    background: 'linear-gradient(to bottom, #fff, #f9fbfe)',
                    boxShadow: '0 8px 20px rgba(85, 110, 230, 0.1), 0 2px 8px rgba(0, 0, 0, 0.05)',
                    overflow: 'hidden',
                    border: 'none',
                    transition: 'all 0.05s ease-in-out'
                  }}
                >
                  <Accordion.Header
                    style={{
                      background: 'transparent',
                      border: 'none',
                      width: '100%',
                      borderRadius: '18px 18px 0 0',
                      transition: 'all 0.3s ease'
                    }}
                    onClick={() => this.setState({ durationsAccordionOpen: !this.state.durationsAccordionOpen })}
                  >
                    <div 
                      className="d-flex align-items-center w-100" 
                      style={{ 
                        fontWeight: '600', 
                        fontSize: '12px', 
                        color: '#556ee6',
                        letterSpacing: '0.2px'
                      }}
                    >
                      <div 
                        style={{
                          backgroundColor: 'rgba(85, 110, 230, 0.1)',
                          borderRadius: '50%',
                          width: '32px',
                          height: '32px',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          marginRight: '12px'
                        }}
                      >
                        <BarChart size={16} color="#556ee6" />
                      </div>
                      Durations
                    </div>
                  </Accordion.Header>
                  {this.state.historical_dag_runs[this.state.selected_job] && (
                    <Accordion.Body 
                      className="animate__animated animate__fadeIn" 
                      style={{ 
                        padding: '18px 25px 22px',
                        backgroundColor: 'transparent',
                        borderTop: 'none',
                        borderRadius: '0 0 18px 18px',
                        transition: 'all 0.3s ease-in-out',
                        height: "240px"
                      }}
                    >
                    <div style={{ height: "200px" }}>
                      <Bar
                      data={{
                        labels: this.state.historical_dag_runs[this.state.selected_job]
                          ?.slice(0, 20)
                          ?.reverse()
                          ?.map(run => {
                            if (!run.start_date || run.start_date === "Seconds ago") {
                              return "Now";
                            }
                            return moment.utc(run.start_date).tz(customer_timezone)?.format("MMM DD HH:mm");
                          })
                          || [],
                        datasets: [{
                          label: 'Duration (minutes)',
                          data: this.state.historical_dag_runs[this.state.selected_job]
                            ?.slice(0, 20)
                            ?.reverse()
                            ?.map(run => {
                              const durationStr = run.duration || "0 min";
                              return Math.round(parseFloat(durationStr.replace(" min", "")) || 0);
                            })
                            || [],
                          backgroundColor: this.state.historical_dag_runs[this.state.selected_job]
                            ?.slice(0, 20)
                            ?.reverse()
                            ?.map(run => {
                              if (run.state === 'success') return 'rgba(84, 203, 117, 0.8)';
                              if (run.state === 'failed') return 'rgba(255, 99, 132, 0.8)';
                              if (run.state === 'running') return 'rgba(54, 162, 235, 0.8)';
                              return 'rgba(169, 169, 169, 0.8)';
                            })
                            || [],
                          borderColor: this.state.historical_dag_runs[this.state.selected_job]
                            ?.slice(0, 20)
                            ?.reverse()
                            ?.map(run => {
                              if (run.state === 'success') return 'rgba(84, 203, 117, 1)';
                              if (run.state === 'failed') return 'rgba(255, 99, 132, 1)';
                              if (run.state === 'running') return 'rgba(54, 162, 235, 1)';
                              return 'rgba(169, 169, 169, 1)';
                            })
                            || [],
                          borderWidth: 1
                        }]
                      }}
                      options={{
                        responsive: true,
                        maintainAspectRatio: false,
                        layout: {
                          padding: {
                            bottom: 10
                          }
                        },
                        plugins: {
                          legend: {
                            display: false
                          },
                          tooltip: {
                            callbacks: {
                              afterLabel: (context) => {
                                const reversedRuns = this.state.historical_dag_runs[this.state.selected_job]?.slice(0, 20)?.reverse();
                                const run = reversedRuns?.[context.dataIndex];
                                if (run) {
                                  return [
                                    `Status: ${run.state}`,
                                    `Started: ${moment.utc(run.start_date).tz(customer_timezone)?.format("YYYY-MM-DD HH:mm")}`,
                                    `Run Type: ${run.run_type}`
                                  ];
                                }
                                return [];
                              }
                            }
                          }
                        },
                        scales: {
                          y: {
                            beginAtZero: true,
                            title: {
                              display: false
                            },
                            ticks: {
                              stepSize: 1,
                              callback: function(value) {
                                return Math.round(value) + ' min';
                              }
                            }
                          },
                          x: {
                            title: {
                              display: false
                            }
                          }
                        }
                      }}
                      height={200}
                    />
                    </div>
                    </Accordion.Body>
                  )}
                </Accordion.Item>
              </Accordion>
              {/* Runs Accordion */}
              <Accordion defaultActiveKey={this.state.runsAccordionOpen ? "0" : ""} className="pl-0 modern-accordion mb-3" style={{ margin: "10px 0" }}>
                <Accordion.Item
                  eventKey="0"
                  className="bg-white"
                  style={{
                    borderRadius: '18px',
                    background: 'linear-gradient(to bottom, #fff, #f9fbfe)',
                    boxShadow: '0 8px 20px rgba(85, 110, 230, 0.1), 0 2px 8px rgba(0, 0, 0, 0.05)',
                    overflow: 'hidden',
                    border: 'none',
                    transition: 'all 0.05s ease-in-out'
                  }}
                >
                  <Accordion.Header
                    style={{
                      background: 'transparent',
                      border: 'none',
                      width: '100%',
                      borderRadius: '18px 18px 0 0',
                      transition: 'all 0.3s ease'
                    }}
                    onClick={() => this.setState({ runsAccordionOpen: !this.state.runsAccordionOpen })}
                  >
                    <div 
                      className="d-flex align-items-center w-100" 
                      style={{ 
                        fontWeight: '600', 
                        fontSize: '12px', 
                        color: '#556ee6',
                        letterSpacing: '0.2px'
                      }}
                    >
                      <div 
                        style={{
                          backgroundColor: 'rgba(85, 110, 230, 0.1)',
                          borderRadius: '50%',
                          width: '32px',
                          height: '32px',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          marginRight: '12px'
                        }}
                      >
                        <Settings size={16} color="#556ee6" />
                      </div>
                      Runs
                    </div>
                  </Accordion.Header>
                  <Accordion.Body 
                    className="animate__animated animate__fadeIn" 
                    style={{ 
                      padding: '0 0 5px 0',
                      backgroundColor: 'transparent',
                      borderTop: 'none',
                      borderRadius: '0 0 18px 18px',
                      transition: 'all 0.3s ease-in-out'
                    }}
                  >
                    {this.state.fetching_last_runs ? (
                      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '200px' }}>
                        <DatajoltSpinner />
                      </div>
                    ) : (!this.state.historical_runs_available || !this.state.historical_dag_runs[this.state.selected_job]?.length) ? (
                      <center className="no-history-text" onClick={() => this.props.onClose()} style={{ padding: '40px 0' }}>
                        <b>No historical runs of this job yet.</b>{" "}
                        <ChevronsRight width={14} />
                      </center>
                    ) : (
                      <TableContainer sx={{
                        [`& .${tableHeadClasses.root}`]: {
                          position: "relative"
                        },
                        width: "100%",
                        minWidth: "100%",
                        tableLayout: "fixed"
                      }}>
                        <Table
                  headings={[
                    {
                      isSortable: false,
                      columnName: "date",
                      Children: () => "Date",
                      width: "12%",
                    },
                    {
                      isSortable: false,
                      columnName: "started",
                      Children: () => "Started",
                      width: "18%",
                    },
                    {
                      isSortable: false,
                      columnName: "ended",
                      Children: () => "Ended",
                      width: "18%",
                    },
                    {
                      isSortable: false,
                      columnName: "duration",
                      Children: () => "Duration",
                      width: "12%",
                    },
                    {
                      isSortable: false,
                      columnName: "status",
                      Children: () => "Status",
                      width: "12%",
                    },
                    {
                      isSortable: false,
                      columnName: "run",
                      Children: () => "Triggered by",
                      width: "18%",
                    },
                    {
                      isSortable: false,
                      columnName: "logs",
                      Children: () => "Logs",
                      width: "10%",
                    },
                    ...(this.props.hideTaskTimeline ? [] : [{
                      isSortable: false,
                      columnName: "more",
                      Children: () => " Timeline",
                      width: "10%",
                    }]),
                  ]}
                  rows={this.state.historical_dag_runs[
                    this.state.selected_job
                  ]?.map((DAG) => ({
                    key: DAG.dag_run_id,
                    columns: [
                      {
                        type: "text",
                        text:
                          DAG.start_date && DAG.start_date !== "Seconds ago"
                            ? moment
                                .utc(DAG.start_date)
                                .tz(customer_timezone)
                                ?.format("YYYY-MM-DD")
                            : "Today",
                      },
                      {
                        type: "text",
                        text:
                          DAG.start_date && DAG.start_date !== "Seconds ago"
                            ? moment
                                .utc(DAG.start_date)
                                .tz(customer_timezone)
                                ?.format("YYYY-MM-DD HH:mm")
                            : "Seconds ago",
                      },
                      {
                        type: "text",
                        text: DAG.end_date
                          ? moment
                              .utc(DAG.end_date)
                              .tz(customer_timezone)
                              ?.format("YYYY-MM-DD HH:mm")
                          : "",
                      },
                      { type: "text", text: DAG.duration },
                      { type: "status", key: DAG.state },
                      { 
                        type: "component",
                        component: (
                          <div 
                            title={DAG.run_type}
                            style={{
                              wordBreak: "break-word",
                              maxWidth: "120px",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap",
                              cursor: "default"
                            }}
                          >
                            {DAG.run_type}
                          </div>
                        )
                      },
                      {
                        type: "component",
                        component: (
                          <Button
                            disabled={!this.props.show_logs}
                            variant="contained"
                            onClick={() => {
                              // Close Gantt chart if open
                              this.setState({ showTaskGantt: null });
                              this.gettasks(
                                DAG.state,
                                this.state.dag_id || DAG.dag_id,
                                DAG.dag_run_id,
                                DAG.start_date
                              );
                            }}
                            size="small"
                            sx={{
                              backgroundColor: "#2d49fd",
                              border: "1px solid #2d49fd",
                              padding: "5px",
                              minWidth: "0",
                              "&:disabled": {
                                backgroundColor: "#2d49fd",
                              }
                            }}
                          >
                            {this.state.fetching_logs &&
                            DAG.dag_run_id === this.state.loading_log_id ? (
                              <center className="rotate-icon">
                                <Loader size={16} color="white" />
                              </center>
                            ) : DAG.dag_run_id === this.state.modal_logs ? (
                              <ArrowDown size={16} color="white" />
                            ) : (
                              <Code size={16} color="white" />
                            )}
                          </Button>
                        ),
                      },
                      ...(this.props.hideTaskTimeline ? [] : [{
                        type: "component",
                        component: (
                          <div style={{ display: "flex", justifyContent: "center", alignItems: "center", width: "100%" }}>
                            <Button
                              variant="contained"
                              onClick={() => {
                                if (this.state.showTaskGantt === DAG.dag_run_id) {
                                  this.setState({ showTaskGantt: null });
                                } else {
                                  // Close logs if open and load task data for Gantt chart
                                  this.setState({ 
                                    modal_logs: false,
                                    dag_logs: [],
                                    gantt_logs: [] // Clear old gantt data to prevent flash
                                  });
                                  this.getTasksForGantt(
                                    DAG.state,
                                    this.state.dag_id || DAG.dag_id,
                                    DAG.dag_run_id,
                                    DAG.start_date
                                  );
                                  this.setState({ showTaskGantt: DAG.dag_run_id });
                                }
                              }}
                              size="small"
                              sx={{
                                backgroundColor: "#2d49fd",
                                border: "1px solid #2d49fd",
                                padding: "5px",
                                minWidth: "0",
                              }}
                              title="Task timeline"
                            >
                              {this.state.showTaskGantt === DAG.dag_run_id ? (
                                <ArrowDown size={16} color="white" />
                              ) : (
                                <Clock size={16} color="white" />
                              )}
                            </Button>
                          </div>
                        ),
                      }]),
                    ],
                    logsTable: (DAG.dag_run_id === this.state.modal_logs || DAG.dag_run_id === this.state.showTaskGantt) && (
                      this.state.showTaskGantt === DAG.dag_run_id ? (
                        // Render Gantt Chart
                      <tr style={{ background: "transparent", outline: "none", padding: 0 }}>
                        <td
                          colSpan="100%"
                          style={{ background: "transparent", outline: "none", padding: 0 }}
                        >
                          <div style={{ 
                            marginTop: "10px", 
                            marginBottom: "10px",
                            padding: "16px", 
                            background: "white", 
                            border: "1px solid #dde6ec", 
                            borderRadius: "8px",
                            height: "360px"
                          }}>
                            <h6 style={{ marginBottom: "12px", fontWeight: "bold" }}>Task Timeline</h6>
                            {!this.state.fetching_gantt && this.state.gantt_logs && this.state.gantt_logs.length > 0 ? (
                              (() => {
                                const { labels, datasets, sortedLogs } = this.transformDataForGantt(this.state.gantt_logs);
                                // Calculate dynamic height based on number of tasks (40px per task, minimum 300px)
                                const chartHeight = Math.max(300, labels.length * 40);
                                return (
                                  <div style={{ height: "300px", overflowY: "auto", width: "100%" }}>
                                    <Bar
                                    data={{ labels, datasets }}
                                    options={{
                                      indexAxis: 'y',
                                      responsive: false,
                                      maintainAspectRatio: false,
                                      layout: {
                                        padding: {
                                          bottom: 20
                                        }
                                      },
                                      elements: {
                                        bar: {
                                          barThickness: 20,
                                          maxBarThickness: 20
                                        }
                                      },
                                      plugins: {
                                        legend: {
                                          display: false
                                        },
                                        tooltip: {
                                          callbacks: {
                                            label: (context) => {
                                              const taskData = datasets[0].taskData[context.dataIndex];
                                              return [
                                                `Duration: ${Math.round(taskData.duration)} minutes`,
                                                `Status: ${taskData.status}`,
                                                `Started: ${taskData.startFormatted}`,
                                                `Ended: ${taskData.endFormatted}`
                                              ];
                                            }
                                          }
                                        }
                                      },
                                      scales: {
                                        x: {
                                          beginAtZero: true,
                                          title: {
                                            display: false
                                          },
                                          ticks: {
                                            stepSize: 1,
                                            callback: function(value) {
                                              const roundedValue = Math.round(value);
                                              return roundedValue === 0 ? '' : roundedValue + ' min';
                                            }
                                          }
                                        },
                                        y: {
                                          title: {
                                            display: false
                                          },
                                          ticks: {
                                            autoSkip: false,
                                            maxRotation: 0,
                                            minRotation: 0
                                          },
                                          afterFit: function(scaleInstance) {
                                            scaleInstance.width = 250; // Set width for task names
                                          }
                                        }
                                      }
                                    }}
                                    height={chartHeight}
                                    width={800}
                                  />
                                  </div>
                                );
                              })()
                            ) : (
                              <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '250px' }}>
                                <DatajoltSpinner />
                              </div>
                            )}
                          </div>
                        </td>
                      </tr>
                      ) : (
                        // Render Logs Table
                        <LogsTable
                          show={this.state.modal_logs}
                          onHide={() => this.setState({ modal_logs: false })}
                          selected_job={this.state.selected_job}
                          dag_started_at={this.state.dag_started_at}
                          selected_dag_state={this.state.selected_dag_state}
                          dag_logs={this.state.dag_logs}
                        />
                      )
                    )
                  }))}
                        />
                      </TableContainer>
                    )}
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>

            </div>
          </CSSTransition>
        </div>
      </div>
    );
  }
}

export default DagHistory;
